var sitemap = new function () {
    this.masonry = function () {
        if ($('.sitemap .row').length) {
            setTimeout(function() {
                $('.sitemap .row').masonry({
                    itemSelector: '.sitemap__col',
                    percentPosition: true,
                    columnWidth: '.sitemap__col-sizer'
                });
             }, 100);
        }
    };
};
sitemap.masonry();